import React, {Component} from 'react'
import data from '../data/collections.json.bak'
import CollectionView from "./CollectionView";
import {withTranslation} from "react-i18next";

class Page extends Component {
    render = () => {
        const {t} = this.props;
        const collections = t('collections', {returnObjects: true}).map((album, key) => {
            return (
                <div className='collection-block'>
                    <CollectionView key={key} album={album}/>
                </div>)
        })
        return (
            <div className='container collections'>
                <div className='row'>
                    {collections}
                </div>
            </div>
        );
    };
}

export default withTranslation()(Page);


// WEBPACK FOOTER //
// ./src/components/Collections.jsx